import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-payspace-payroll-and-hr.component.scss';
var FormItemPayspacePayrollAndHr = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemPayspacePayrollAndHr, _super);
    function FormItemPayspacePayrollAndHr(element) {
        return _super.call(this, element) || this;
    }
    FormItemPayspacePayrollAndHr.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-payspace-payroll-and-hr__button');
        this.contactNumber = this.element.querySelector('input[name=contact-number]');
        this.firstName = this.form.querySelector("input[name=first-name]");
        this.lastName = this.form.querySelector("input[name=last-name]");
        this.firstName.setAttribute('maxlength', '60');
        this.lastName.setAttribute('maxlength', '60');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemPayspacePayrollAndHr.prototype.bindEvents = function () {
        var _this = this;
        this.contactNumber.addEventListener("input", function () {
            this.value = this.value.replace(/[e\+\-\,]/gi, "");
        });
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            formFields = Array.from(formFields).filter(function (item) { return item['name'] !== 'registrationnumber'; });
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        if (pEvent.target['name'] !== 'registrationnumber') {
                            _this.validationService.validateBlur(pEvent.currentTarget);
                        }
                    });
                });
            }
        }
        var payrollsystem = Array.from(this.form.querySelectorAll("input[name='payrollsystem']"));
        var numberofemployees = this.form.getElementsByClassName("numberofemployees")[0];
        var Frequencies = this.form.getElementsByClassName('frequencies')[0];
        payrollsystem.map(function (item) { return item.addEventListener("click", function (event) {
            var evt = event.target;
            var value = evt.value;
            if (value === 'NO') {
                numberofemployees.classList.add('hidden');
                Frequencies.classList.add('hidden');
            }
            else if (value === 'YES') {
                numberofemployees.classList.remove('hidden');
                Frequencies.classList.remove('hidden');
            }
        }); });
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemPayspacePayrollAndHr.prototype.validateFormStepRadios = function () {
        var _this = this;
        var allRadiosInStepSelector = "input[type=radio]";
        var _radios = Array.from(this.form.querySelectorAll(allRadiosInStepSelector));
        var tracker = new Map();
        var isStepValid = true;
        _radios.forEach(function (radio) {
            var radios;
            if (!tracker.get(radio.name)) {
                radios = new Array();
                radios.push(radio);
                tracker.set(radio.name, radios);
            }
            else {
                radios = tracker.get(radio.name);
                radios.push(radio);
            }
        });
        Array.from(tracker.keys()).forEach(function (key) {
            var _targetRadios = tracker.get(key);
            var isValid = false;
            var targetElement = null;
            _targetRadios.forEach(function (r) {
                targetElement = r;
                if (targetElement.checked) {
                    isValid = true;
                }
            });
            _this.removeError(targetElement);
            if (!isValid) {
                _this.addError(targetElement, null);
                isStepValid = false;
            }
        });
        return isStepValid;
    };
    FormItemPayspacePayrollAndHr.prototype.addError = function (field, errorMessage) {
        var fieldErrorDetail = errorMessage;
        if (!fieldErrorDetail) {
            fieldErrorDetail = "This field is required";
        }
        var containingDiv = field.closest(".form__group");
        containingDiv.classList.add("form__group--error");
        var _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _errors = document.createElement("ul");
        _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _error = document.createElement("li");
        _error.innerHTML = fieldErrorDetail;
        _errors.appendChild(_error);
        _errorDiv.appendChild(_errors);
        containingDiv.appendChild(_errorDiv);
    };
    FormItemPayspacePayrollAndHr.prototype.removeError = function (field) {
        var containingDiv = field.closest(".form__group");
        if (containingDiv.classList.contains("form__group--error")) {
            containingDiv.classList.remove("form__group--error");
            containingDiv.removeChild(containingDiv.lastChild);
            return true;
        }
        return false;
    };
    FormItemPayspacePayrollAndHr.prototype.submitForm = function (pForm) {
        var _this = this;
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _companyname = this.form.querySelector("input[name=companyname]");
        var _industry = this.form.querySelector("input[name=industry]");
        var _registrationnumber = this.form.querySelector("input[name=registrationnumber]");
        var _payrollsystem = this.form.querySelector("input[name=payrollsystem]");
        var _numberofemployees = this.form.querySelector("input[name=numberofemployees]");
        var _frequencies = this.form.querySelector("input[name=frequencies]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=emailAddress]");
        var email = this.form.querySelector("input[name=email]");
        var recipient = this.form.querySelector("input[name=recipient]");
        var subject = this.form.querySelector("input[name=subject]");
        var _postData = {
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'email': (email ? email.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'firstname': (_firstname ? _firstname.value : ""),
            'lastname': (_lastName ? _lastName.value : ""),
            'contact': (_contact ? _contact.value : ""),
            'companyname': (_companyname ? _companyname.value : ""),
            'industry': (_industry ? _industry.value : ""),
            'registrationnumber': (_registrationnumber ? _registrationnumber.value : ""),
            'payrollsystem': (_payrollsystem ? _payrollsystem.value : ""),
            'numberofemployees': (_numberofemployees ? _numberofemployees.value : ""),
            'frequencies': (_frequencies ? _frequencies.value : ""),
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/services/genericform.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            _this.analyticsService.dtmFormComplete("complete", pResponse.code);
            _this.showDisplayView("success");
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemPayspacePayrollAndHr.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemPayspacePayrollAndHr;
}(Base));
export { FormItemPayspacePayrollAndHr };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-payspace-payroll-and-hr/form-item-payspace-payroll-and-hr.component.ts
// module id = 954
// module chunks = 0